export function routes($stateProvider) {
    $stateProvider
        .state('app.ativos.colaboradores', {
        url: '/colaboradores',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.ativos.colaboradores.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Colaboradores',
        template: require('./directory/directory.view.html'),
        controller: 'AtvColaboradoresListController',
        controllerAs: 'vm',
        role: 'atvListarColaboradores',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "name",
                dynamic: true
            },
            sort: {
                value: "asc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.ativos.colaboradores.details', {
        url: '/{id}',
        title: 'Colaborador',
        controller: 'AtvColaboradoresDetailsController',
        controllerAs: 'vm',
        template: require('./details/details.view.html'),
        role: 'atvListarColaboradores'
    });
}
routes.$inject = ['$stateProvider'];
